import { call, put, all, takeEvery, select } from "redux-saga/effects";

import { customerActions } from '../slice/customerSlice'
import { getAllCustomerApi, updateStaffApi, removeStaffApi, getAllCustomerSelectApi } from 'services/authServices'
import { customerSelector } from 'redux/selector'

function* handleGetCustomer(action) {
    try {
        const res = yield call(getAllCustomerApi, action.payload.query, action.payload.sex, action.payload.currentPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(customerActions.getCustomerSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(customerActions.getCustomerFailed())
            }
        }
        else {
            yield put(customerActions.getCustomerFailed())
        }
    } catch (error) {
        yield put(customerActions.getCustomerFailed())
    }
}

function* handleGetAllCustomer() {
    try {
        const res = yield call(getAllCustomerSelectApi)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(customerActions.getAllCustomerSuccess({ data: response.data }))
            }
            else {
                yield put(customerActions.getAllCustomerFailed())
            }
        }
        else {
            yield put(customerActions.getAllCustomerFailed())
        }
    } catch (error) {
        yield put(customerActions.getAllCustomerFailed())
    }
}


function* handleUpdateCustomer(action) {
    try {
        const res = yield call(updateStaffApi, action.payload.data.account_id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(customerActions.updateCustomerSuccess())
                action.payload.ShowToast('success', 'Khóa tài khoản thành công!')
                yield put(customerActions.getCustomer({ query: action.payload.querySearch, sex: action.payload.sex, currentPage: action.payload.currentPage }))
            } else {
                yield put(customerActions.updateCustomerFailed())
            }
        }
        else {
            yield put(customerActions.updateCustomerFailed())
            action.payload.ShowToast('error', 'Khóa tài khoản thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(customerActions.updateCustomerFailed())
        action.payload.ShowToast('error', 'Khóa tài khoản thất bại, vui lòng thử lại sau!')
    }
}



function* handleRemoveCustomer(action) {
    try {
        const res = yield call(removeStaffApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(customerActions.removeCustomerSuccess())
                const customerState = yield select(customerSelector)
                let totalPage = customerState.totalPage
                if (customerState.customerList.length === 1) {
                    totalPage = totalPage - 1
                    yield put(customerActions.setTotalPage(totalPage))
                    action.payload.setCurrentPage(action.payload.currentPage - 1)
                    yield History.navigate(`/admin/customer?page=${action.payload.currentPage - 1}`);
                }
                action.payload.ShowToast("success", 'Xóa tài khoản thành công!')
                yield put(customerActions.getCustomer({ query: action.payload.querySearch, sex: action.payload.sex, currentPage: action.payload.currentPage }))

            } else {
                yield put(customerActions.removeCustomerFailed())
                action.payload.ShowToast('error', `Xóa tài khoản thất bại, tài khoản đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
            }
        }
        else {
            yield put(customerActions.removeCustomerFailed())
            action.payload.ShowToast('error', `Xóa tài khoản thất bại, tài khoản đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
        }
    } catch (error) {
        yield put(customerActions.removeCustomerFailed())
        action.payload.ShowToast('error', `Xóa tài khoản thất bại, tài khoản đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
    }
}


export default function* customerSaga() {
    yield all(
        [
            takeEvery(customerActions.getCustomer.type, handleGetCustomer),
            takeEvery(customerActions.updateCustomer.type, handleUpdateCustomer),
            takeEvery(customerActions.removeCustomer.type, handleRemoveCustomer),
            takeEvery(customerActions.getAllCustomer.type, handleGetAllCustomer),
        ]
    )
}
